import { render } from "./NewTimeModal.vue?vue&type=template&id=6315b415&scoped=true"
import script from "./NewTimeModal.vue?vue&type=script&lang=js"
export * from "./NewTimeModal.vue?vue&type=script&lang=js"

import "./NewTimeModal.vue?vue&type=style&index=0&id=6315b415&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6315b415"]])

export default __exports__